import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IonHeader, IonToolbar} from '@ionic/react';
import classNames from 'classnames';

import {addAwardNotificationToQueue} from 'shared/actions/award-notifications';
import usePlatformContext from 'src/hooks/usePlatform';
import Colors from '../../aptitude/colors';
import {AWARD_MAP} from './award-map';
import {Store} from 'src/types/store';

import AwardNotification from './award-notification';

import styles from './styles.module.scss';

const colorsByType = {
  'college-interaction': Colors.v200,
  'community-service': Colors.v600,
  courses: Colors.b400,
  extracurricular: Colors.m600,
  'honors-and-awards': Colors.m400,
  multimedia: Colors.p500,
  referral: Colors.g600,
  'test-scores': Colors.c500,
  'work-experience': Colors.m800,
};

const AwardNotifications = () => {
  const dispatch = useDispatch();
  const {activeAward} = useSelector((state: Store) => state.awardNotifications);
  const {isIonic} = usePlatformContext();
  const [showAward, setShowAward] = useState(false);

  useEffect(() => {
    if (activeAward) {
      setShowAward(true);
    } else {
      setTimeout(() => setShowAward(false), 400);
    }
  }, [activeAward]);

  useEffect(() => {
    window.Raise.vent.on('award:notification', (scholarship) => {
      dispatch(addAwardNotificationToQueue(scholarship));
    });
  }, [dispatch]);

  const color = colorsByType[AWARD_MAP[activeAward?.scholarship?._type]?.type];

  return (
    <div className="award-notification-container">
      {showAward && (
        <div
          className={classNames('award-notification', {visible: activeAward, hidden: !activeAward})}
        >
          {isIonic && (
            <IonHeader className={styles.mobileHeader}>
              <IonToolbar
                className={styles.mobileToolbar}
                style={{
                  '--ion-toolbar-background': color,
                  '--ion-toolbar-border-color': color,
                }}
              />
            </IonHeader>
          )}
          <AwardNotification />
        </div>
      )}
    </div>
  );
};

export default AwardNotifications;
